import { gql, useQuery } from '@apollo/client'
import React from 'react'

export default function ElectionHeader() {

  const { data } = useQuery(gql`
    query {
      voted: usersLength(voted: true)
      total: usersLength
    }
  `, {
    pollInterval: 100
  })

  return (
    <header className="py-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-row justify-between">
        <div>
          <h1 className="text-xl md:text-3xl md:font-bold text-white capitalize">Election</h1>
        </div>

        <div>
          <h1 className="md:hidden text-xl md:text-3xl md:font-bold text-white capitalize">{data?.voted}/{data?.total} Votes</h1>
          <h1 className="hidden md:block text-xl md:text-3xl md:font-bold text-white capitalize">{data?.voted}/{data?.total} Votes Cast</h1>
        </div>
      </div>
    </header>
  )
}
